<template>
  <div class="card-body">
    <h4 class="text-muted text-center">
      {{$t('message.coupons.message.coupon')}}
    </h4>

    <v-text-field :label="$t('message.coupons.message.couponCode')"
                  name="Código do Cupom"
                  v-model="val.codigo"
                  v-validate="'required'"
                  :error-messages="errors.collect($t('message.coupons.message.couponCode'))"
                  @input="$emit('input', val)"></v-text-field>

    <div class="segment">
      <app-select :data-title="$t('message.generics.message.spots')"
                  name="Locais"
                  v-model="val.localId"
                  :data-items="devices"
                  data-max-height="180px"></app-select>
    </div>
  </div>
</template>

<script>
    import vModel from '@mixins/v-model'
    import EventBus from '@packages/event-bus'
    import AppSelect from '@components/Select'
    import _ from "lodash";

    export default {
        components: {
            AppSelect,
        },

        props: {

        },

        data() {
            return {
                devices: []
            }
        },

        methods: {
            reset() {
                this.$validator.reset()
            },

            async validate() {
                await this.$validator.validateAll()

                if (this.$validator.errors.items.length !== 0)
                    return this.$emit('to-general-tab')

                this.$emit('valid')
            },
        },

        mixins: [vModel],

        async mounted() {
            EventBus.$on('RESET_PROMOCIONALCODE_MODAL',  this.reset)
            let devices = await this.$loader.devices.load({
              pagination: {
                page: 0
              }
            })

            this.devices = _.map(devices, (device) => {
                return {
                    id: device.id,
                    label: device.nome
                }
            })
        },
        beforeDestroy() {
            EventBus.$off('RESET_PROMOCIONALCODE_MODAL',  this.reset)
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.card-body {
  padding: 18px 50px 10px;

  .v-input {
    margin: 12px 0 10px 0;
  }

  .dates {
    display: flex;
    margin-bottom: 32px;

    .date {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 0 auto;

      .datepicker-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 175px;
        height: 55px;
        padding: 0 15px;
        border: $border-1;
        border-radius: 4px;
        font-weight: bold;
        color: $grey-4;

        .mdi {
          font-size: 24px;
        }

        input {
          color: $grey-4;
        }
      }
    }
  }

  .segment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    & > *:not(:first-child) {
      margin-top: 10px;
    }
  }
}
</style>
